export class DocumentTitleRequiredError extends Error {
  constructor() {
    super();
    Object.setPrototypeOf(this, DocumentTitleRequiredError.prototype);
  }
}
